export default function IconAngle(props: any) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000" fill="currentColor" {...props}>
  <path d="m597.1,701.56c-8.2,7.03-19.92,5.86-26.95-1.17l-168.75-187.5c-5.86-7.03-5.86-18.75,0-25.78l168.75-187.5c7.03-7.03,18.75-8.2,26.95-1.17s7.03,18.75,1.17,26.95l-157.03,174.61,157.03,174.61c7.03,8.2,5.86,19.92-1.17,26.95Z"/>
</svg>;
}
